export default __webpack_public_path__ + "static/media/mail-sent.3b320180.svg";